var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M24.792 10.675C22.097 6.44 18.153 4.002 14 4.002c-2.076 0-4.095.606-5.938 1.738-1.843 1.143-3.5 2.812-4.853 4.935-1.167 1.832-1.167 4.807 0 6.638C5.903 21.56 9.846 23.987 14 23.987c2.077 0 4.095-.607 5.939-1.739 1.843-1.143 3.5-2.811 4.853-4.935 1.166-1.82 1.166-4.806 0-6.638M14 18.713A4.71 4.71 0 0 1 9.287 14c0-2.602 2.1-4.713 4.713-4.713A4.71 4.71 0 0 1 18.714 14c0 2.602-2.1 4.713-4.714 4.713"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M14 10.663a3.331 3.331 0 0 0 0 6.662c1.832 0 3.337-1.493 3.337-3.325A3.35 3.35 0 0 0 14 10.663"
  })));
};
export default SvgEye;